import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Heading, TitleAdditional } from '../Elements';

import classes from './PageSubTitle.module.scss';

const PageSubTitle = ({
  title,
  additional,
  className,
  classNameHeading,
  hiden,
  size = 2,
  weight = 'm'
}) => {
  return (
    <div
      className={cn(classes.box, className, hiden && classes.visually_hidden)}
    >
      <Heading size={size} weight={weight} className={classNameHeading}>
        {title}
        {(additional || additional === 0) && (
          <TitleAdditional data={additional} />
        )}
      </Heading>
    </div>
  );
};

PageSubTitle.propTypes = {
  title: PropTypes.string.isRequired,
  additional: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  classNameHeading: PropTypes.string,
  hiden: PropTypes.bool,
  size: PropTypes.number,
  weight: PropTypes.string
};

export default PageSubTitle;
